import BaseApi from './base'
import config from '../../config.json'

export default class LevelsApi extends BaseApi {
  constructor() {
    super()
  }

  getAll() {
    return this.axios
      .get(`${config.apiUrl}/levels/get_all`)
      .then(response => response.data)
  }

  getActiveLevelIntervals() {
    return this.axios
      .get(`${config.apiUrl}/levels/get_active_levels_interval`)
      .then(response => response.data)
  }
}
